import { useQuery } from "@tanstack/react-query";
import { getNavConfig } from "./api";

const pos = (ord, id, fallback) => { const i = (ord || []).indexOf(id); return i === -1 ? 1000 + fallback : i; };

// Owner's Arrange edits (rename / reorder / move tabs between groups) applied on top of the built-in sections.
export function arrangeSections(base, st) {
    if (!st || !base?.length) return base;
    const groups = base.map((s) => ({ ...s, title: st.groups?.[s.key]?.title || s.title, tabs: [] }));
    const byKey = Object.fromEntries(groups.map((g) => [g.key, g]));
    const orig = {};
    base.forEach((s) => (s.tabs || []).forEach((t, i) => {
        const o = st.tabs?.[t.id] || {};
        const g = byKey[o.group] || byKey[s.key];
        orig[t.id] = i;
        g.tabs.push({ ...t, l: o.l || t.l });
    }));
    groups.forEach((g) => { const ord = st.tab_order?.[g.key]; if (ord) g.tabs.sort((a, b) => pos(ord, a.id, orig[a.id]) - pos(ord, b.id, orig[b.id])); });
    const bi = Object.fromEntries(base.map((s, i) => [s.key, i]));
    if (st.group_order) groups.sort((a, b) => pos(st.group_order, a.key, bi[a.key]) - pos(st.group_order, b.key, bi[b.key]));
    const logo = groups.findIndex((g) => g.isLogo);
    if (logo > 0 && !(st.group_order || []).includes(groups[logo].key)) groups.unshift(groups.splice(logo, 1)[0]);
    return groups;
}

export function useNavStructure() {
    const { data } = useQuery({ queryKey: ["nav-config"], queryFn: getNavConfig, staleTime: 5 * 60 * 1000 });
    return data?.nav_structure || null;
}
